export default function parseDataToProps(dataset) {
    const props = {};

    // Parse dataset to valid props
    for (const key in dataset) {
        if (Object.prototype.hasOwnProperty.call(dataset, key)) {
            props[key] = dataset[key];

            try {
                props[key] = JSON.parse(props[key]);
            } catch (e) {
                // Ignore parsing errors
            }
        }
    }

    return props;
}
